module.exports = __webpack_public_path__ + "static/img/25.1a356d02.png";